/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import { Container } from 'components/ui';
import ComponentList from 'components/Content/ComponentList';
import contentConstants from 'constants/content';
import Breadcrumb from 'components/Content/Breadcrumb';
import NavigationCarousel from 'components/Content/NavigationCarousel';
import { mountHeroBanner } from 'utils/Layout';

const { CONTEXTS } = contentConstants;

class LayoutBuyingGuide extends BaseClass {
    constructor(props) {
        super(props);
        this.navRef = React.createRef();
    }

    render() {
        const { localization, breadcrumbs, seo, navigation } = this.props;
        const { heroBanner, content } = this.props.content;
        const isChild = !navigation?.action?.isCurrent;

        const heroBannerProps = mountHeroBanner({
            heroBanner,
            seo,
            isChild,
            navigation
        });

        return (
            <Container paddingX={[0, 4]}>
                <Container paddingX={[4, 0]}>
                    {breadcrumbs && (
                        <Breadcrumb
                            breadcrumbs={breadcrumbs}
                            localization={localization?.breadcrumb}
                            fontSize='sm-bg'
                        />
                    )}
                </Container>
                {isChild && navigation?.items && (
                    <NavigationCarousel
                        variant={'link'}
                        navigation={navigation}
                    />
                )}
                {heroBannerProps && (
                    <ComponentList
                        enablePageRenderTracking={true}
                        trackingCount={1}
                        context={CONTEXTS.CONTAINER}
                        page='buying-guide'
                        items={[heroBannerProps]}
                    />
                )}
                {!isChild && navigation?.items && <NavigationCarousel navigation={navigation} />}
                <Container paddingX={[4, 0]}>
                    {content?.length && (
                        <ComponentList
                            enablePageRenderTracking={true}
                            trackingCount={1}
                            context={CONTEXTS.CONTAINER}
                            page='buying-guide'
                            items={content}
                            removeLastItemMargin={true}
                            removeFirstItemMargin={true}
                        />
                    )}
                </Container>
            </Container>
        );
    }
}

LayoutBuyingGuide.propTypes = {
    navigation: PropTypes.object,
    seo: PropTypes.object,
    breadcrumbs: PropTypes.array
};

LayoutBuyingGuide.defaultProps = {
    navigation: null,
    seo: null,
    breadcrumbs: null
};

export default wrapComponent(LayoutBuyingGuide, 'LayoutBuyingGuide', true);
